import React from "react";
import { motion } from "framer-motion";
import { ROADMAP } from "../lib/constants";

const Card = ({ phase, idx }) => {
    const isCurrent = phase.status === "current";
    const isComplete = phase.status === "complete";
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            data-testid={`roadmap-phase-${phase.id}`}
            className={`relative p-6 sm:p-7 border-2 ${
                isCurrent
                    ? "border-pink-brand bg-[#14110f] animate-pulse-glow"
                    : isComplete
                    ? "border-yellow-brand/60 bg-[#14110f]/80"
                    : "border-white/10 bg-[#14110f]/60"
            }`}
        >
            <div className="flex items-start justify-between mb-4">
                <div className="font-mono-soft text-xs uppercase tracking-[0.25em] text-[#a19d9a]">
                    Phase 0{phase.id}
                </div>
                {isCurrent ? (
                    <span
                        data-testid={`current-badge-${phase.id}`}
                        className="inline-flex items-center gap-1.5 bg-pink-brand text-white px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest"
                    >
                        <span className="w-1.5 h-1.5 rounded-full bg-yellow-brand animate-pulse" />
                        Current
                    </span>
                ) : isComplete ? (
                    <span
                        data-testid={`complete-badge-${phase.id}`}
                        className="inline-flex items-center gap-1.5 bg-yellow-brand text-[#0a0806] px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest"
                    >
                        ✓ Complete
                    </span>
                ) : (
                    <span className="text-[10px] font-mono-soft uppercase tracking-widest text-[#a19d9a]">
                        Upcoming
                    </span>
                )}
            </div>
            <h3 className={`font-display text-3xl sm:text-4xl uppercase mb-3 ${
                isCurrent ? "text-yellow-brand" : isComplete ? "text-white/80" : "text-white"
            }`}>
                {phase.title}
            </h3>
            <p className={`text-sm leading-relaxed ${
                isCurrent ? "text-white/85" : isComplete ? "text-white/55" : "text-white/55"
            }`}>
                {phase.summary}
            </p>
            <div className={`absolute bottom-0 left-0 h-1 ${
                isCurrent ? "w-full bg-pink-brand" : isComplete ? "w-full bg-yellow-brand/70" : "w-1/4 bg-white/10"
            }`} />
        </motion.div>
    );
};

export const Roadmap = () => {
    return (
        <section
            id="roadmap"
            data-testid="roadmap-section"
            className="py-24 sm:py-32 relative bg-[#0a0806]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mb-16 max-w-3xl">
                    <div className="font-mono-soft text-xs uppercase tracking-[0.3em] text-yellow-brand mb-4">
                        // The Plan
                    </div>
                    <h2 className="font-display text-5xl sm:text-6xl md:text-7xl uppercase leading-[0.9]">
                        Roadmap to <span className="text-pink-brand">launch</span>.
                    </h2>
                    <p className="mt-5 text-lg text-white/70">
                        Four phases. One mission. We're currently in <span className="text-yellow-brand font-bold">Phase 3: Expansion</span>.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                    {ROADMAP.map((p, i) => (
                        <Card key={p.id} phase={p} idx={i} />
                    ))}
                </div>
            </div>
        </section>
    );
};
